/**
 * Do not edit directly, this file was auto-generated.
 */

export const BorderRadius0 = "0px";
export const BorderRadius150 = "6px";
export const BorderRadius200 = "8px";
export const BorderRadius300 = "12px";
export const BorderRadius400 = "16px";
export const BorderRadius500 = "20px";
export const BorderRadius050 = "2px";
export const BorderRadiusBase = "4px";
export const BorderRadiusFull = "9999px";
export const Breakpoint320px = "320px";
export const Breakpoint400px = "400px";
export const Breakpoint600px = "600px";
export const Breakpoint800px = "800px";
export const Breakpoint960px = "960px";
export const Breakpoint1055px = "1055px";
export const ColorsDarkCandyAppleRed = "#a40300";
export const ColorsRedOrange = "#f75548";
export const ColorsPastelCerulean = "#00a5db";
export const ColorsHeavyMetal = "#2c2c2c";
export const ColorsVibrantBlue = "#0c37f6";
export const ColorsWillowGrove = "#5e7461";
export const ColorsWillowGroveDark = "#5a6d5c";
export const ColorsMarine = "#08375e";
export const ColorsMarineDark = "#073255";
export const ColorsVeronica = "#aa25ee";
export const ColorsParadiso = "#398087";
export const ColorsOrangePeel = "#af800e";
export const ColorsOrangePeelDark = "#a5780d";
export const ColorsPastelUfoGreen = "#08cb5f";
export const ColorsPrimaryBlack = "#000000";
export const ColorsPrimaryWhite = "#ffffff";
export const ColorsPrimaryThunderbird = "#cd0400";
export const ColorsTurquoise50 = "#f1fcfa";
export const ColorsTurquoise100 = "#d0f7f1";
export const ColorsTurquoise200 = "#a0efe4";
export const ColorsTurquoise300 = "#69dfd3";
export const ColorsTurquoise400 = "#4ecdc4";
export const ColorsTurquoise500 = "#20aca4";
export const ColorsTurquoise600 = "#178a86";
export const ColorsTurquoise700 = "#176e6c";
export const ColorsTurquoise800 = "#175858";
export const ColorsTurquoise900 = "#174a49";
export const ColorsTurquoise950 = "#072b2c";
export const ColorsAquamarine50 = "#e9fff8";
export const ColorsAquamarine100 = "#c9ffed";
export const ColorsAquamarine200 = "#98ffe1";
export const ColorsAquamarine300 = "#44ffd1";
export const ColorsAquamarine400 = "#14f3c4";
export const ColorsAquamarine500 = "#00dbad";
export const ColorsAquamarine600 = "#00b38f";
export const ColorsAquamarine700 = "#008f77";
export const ColorsAquamarine800 = "#00715f";
export const ColorsAquamarine900 = "#005c50";
export const ColorsAquamarine950 = "#00342e";
export const ColorsDodgerBlue50 = "#edfbff";
export const ColorsDodgerBlue100 = "#d7f4ff";
export const ColorsDodgerBlue200 = "#b9edff";
export const ColorsDodgerBlue300 = "#88e4ff";
export const ColorsDodgerBlue400 = "#50d2ff";
export const ColorsDodgerBlue500 = "#28b7ff";
export const ColorsDodgerBlue600 = "#0496ff";
export const ColorsDodgerBlue700 = "#0a81eb";
export const ColorsDodgerBlue800 = "#0f67be";
export const ColorsDodgerBlue900 = "#135895";
export const ColorsDodgerBlue950 = "#11365a";
export const ColorsBlue50 = "#ebf4ff";
export const ColorsBlue100 = "#dbeaff";
export const ColorsBlue200 = "#bed7ff";
export const ColorsBlue300 = "#97bbff";
export const ColorsBlue400 = "#6e92ff";
export const ColorsBlue500 = "#4c6cff";
export const ColorsBlue600 = "#293eff";
export const ColorsBlue700 = "#202fe2";
export const ColorsBlue800 = "#1d2cb6";
export const ColorsBlue900 = "#202d8f";
export const ColorsBlue950 = "#131953";
export const ColorsPurpleHeart50 = "#edefff";
export const ColorsPurpleHeart100 = "#dfe1ff";
export const ColorsPurpleHeart200 = "#c5c8ff";
export const ColorsPurpleHeart300 = "#a2a3ff";
export const ColorsPurpleHeart400 = "#867dfc";
export const ColorsPurpleHeart500 = "#745ef6";
export const ColorsPurpleHeart600 = "#623cea";
export const ColorsPurpleHeart700 = "#5833cf";
export const ColorsPurpleHeart800 = "#482ca7";
export const ColorsPurpleHeart900 = "#3c2b84";
export const ColorsPurpleHeart950 = "#25194d";
export const ColorsElectricViolet50 = "#fdf2ff";
export const ColorsElectricViolet100 = "#fae3ff";
export const ColorsElectricViolet200 = "#f4c6ff";
export const ColorsElectricViolet300 = "#f199ff";
export const ColorsElectricViolet400 = "#ea5dff";
export const ColorsElectricViolet500 = "#da21ff";
export const ColorsElectricViolet600 = "#c200fb";
export const ColorsElectricViolet700 = "#a500cf";
export const ColorsElectricViolet800 = "#8800a9";
export const ColorsElectricViolet900 = "#730689";
export const ColorsElectricViolet950 = "#4d005e";
export const ColorsThunderbird50 = "#fff0f0";
export const ColorsThunderbird100 = "#ffdedd";
export const ColorsThunderbird200 = "#ffc2c1";
export const ColorsThunderbird300 = "#ff9795";
export const ColorsThunderbird400 = "#ff5c59";
export const ColorsThunderbird500 = "#ff2a26";
export const ColorsThunderbird600 = "#fc0b06";
export const ColorsThunderbird700 = "#cd0400";
export const ColorsThunderbird800 = "#af0805";
export const ColorsThunderbird900 = "#900f0c";
export const ColorsThunderbird950 = "#500200";
export const ColorsGray500 = "#7f7f7f";
export const ColorsGray600 = "#555555";
export const ColorsGray700 = "#3f3f3f";
export const ColorsGray800 = "#222222";
export const ColorsGray900 = "#111111";
export const ColorsGray250 = "#f7f7f8";
export const ColorsGray2100 = "#eeeef0";
export const ColorsGray2200 = "#d9d9de";
export const ColorsGray2300 = "#b8b9c1";
export const ColorsGray2400 = "#92939e";
export const ColorsGray2500 = "#747583";
export const ColorsGray2600 = "#5e5f6b";
export const ColorsGray2700 = "#4d4e57";
export const ColorsGray2800 = "#42424a";
export const ColorsGray2900 = "#37373d";
export const ColorsGray2950 = "#26262b";
export const ColorsGray2960 = "#18181b";
export const ColorsGray2970 = "#0e0e11";
export const ColorsBanana50 = "#fefce8";
export const ColorsBanana100 = "#fefac3";
export const ColorsBanana200 = "#fff389";
export const ColorsBanana300 = "#fee440";
export const ColorsBanana400 = "#fbd214";
export const ColorsBanana500 = "#ebb907";
export const ColorsBanana600 = "#cb8e03";
export const ColorsBanana700 = "#a26606";
export const ColorsBanana800 = "#86500d";
export const ColorsBanana900 = "#724111";
export const ColorsBanana950 = "#422106";
export const DarkThemeColorTextRequiredMarker = "#f75548";
export const DarkThemeColorTextLink = "#00a5db";
export const DarkThemeColorTextError = "#ff6a67";
export const DarkThemeColorTextSuccess = "#4ffbce";
export const DarkThemeColorTextHighlight = "var(--colors-primary-white)";
export const DarkThemeColorTextPromo = "#f75548";
export const DarkThemeColorTextL0 = "#d8d8d8";
export const DarkThemeColorTextL1 = "#d8d8d8";
export const DarkThemeColorTextL2 = "#d8d8d8";
export const DarkThemeColorTextSecondaryL0 = "var(--colors-gray2-500)";
export const DarkThemeColorTextSecondaryL1 = "var(--colors-gray2-500)";
export const DarkThemeColorTextSecondaryL2 = "var(--colors-gray2-500)";
export const DarkThemeColorTextElementL0 = "#d8d8d8";
export const DarkThemeColorTextElementL1 = "#d8d8d8";
export const DarkThemeColorTextElementL2 = "#d8d8d8";
export const DarkThemeColorTextSecondaryElementL0 = "#bfbfbf";
export const DarkThemeColorTextSecondaryElementL1 = "#bfbfbf";
export const DarkThemeColorTextSecondaryElementL2 = "#bfbfbf";
export const DarkThemeColorTextElementLabelL0 = "#ffffff";
export const DarkThemeColorTextElementLabelL1 = "#ffffff";
export const DarkThemeColorTextElementLabelL2 = "#ffffff";
export const DarkThemeColorTextElementHintL0 = "var(--color-secondary-text-l0)";
export const DarkThemeColorTextElementHintL1 = "var(--color-secondary-text-l1)";
export const DarkThemeColorTextElementHintL2 = "var(--color-secondary-text-l2)";
export const DarkThemeColorTextElementSelectedL0 = "#ffffff";
export const DarkThemeColorTextElementSelectedL1 = "#ffffff";
export const DarkThemeColorTextElementSelectedL2 = "#ffffff";
export const DarkThemeColorDivider = "var(--colors-gray2-960)";
export const DarkThemeColorBgL0 = "var(--colors-primary-black)";
export const DarkThemeColorBgL1 = "#2a2a2a";
export const DarkThemeColorBgL2 = "#3f3f3f";
export const DarkThemeColorBgHoverL0 = "#3f3f3f";
export const DarkThemeColorBgHoverL1 = "#3f3f3f";
export const DarkThemeColorBgHoverL2 = "#222222";
export const DarkThemeColorBgTransparentL0 = "rgba(0, 0, 0, 0)";
export const DarkThemeColorBgTransparentL1 = "rgba(42, 42, 42, 0)";
export const DarkThemeColorBgTransparentL2 = "rgba(63, 63, 63, 0)";
export const DarkThemeColorBgTransparent050L0 = "rgba(0, 0, 0, 0.5)";
export const DarkThemeColorBgTransparent050L1 = "rgba(42, 42, 42, 0.5)";
export const DarkThemeColorBgTransparent050L2 = "rgba(63, 63, 63, 0.5)";
export const DarkThemeColorBgElementL0 = "var(--colors-gray2-960)";
export const DarkThemeColorBgElementL1 = "var(--colors-gray2-900)";
export const DarkThemeColorBgElementL2 = "#2a2a2a";
export const DarkThemeColorBgElementHoverL0 = "var(--colors-gray2-900)";
export const DarkThemeColorBgElementHoverL1 = "#222222";
export const DarkThemeColorBgElementHoverL2 = "#3f3f3f";
export const DarkThemeColorBgElementSelectedL0 = "#cc0d12";
export const DarkThemeColorBgElementSelectedL1 = "#cc0d12";
export const DarkThemeColorBgElementSelectedL2 = "#cc0d12";
export const DarkThemeColorBorderL0 = "#3f3f3f";
export const DarkThemeColorBorderL1 = "#555555";
export const DarkThemeColorBorderL2 = "#222222";
export const DarkThemeColorBorderHoverL0 = "#797979";
export const DarkThemeColorBorderHoverL1 = "rgba(151, 151, 151, 0.5)";
export const DarkThemeColorBorderHoverL2 = "rgba(151, 151, 151, 0.5)";
export const DarkThemeColorBorderElementL0 = "var(--colors-gray2-950)";
export const DarkThemeColorBorderElementL1 = "#222222";
export const DarkThemeColorBorderElementL2 = "#555555";
export const DarkThemeColorBorderElementHoverL0 = "rgba(151, 151, 151, 0.5)";
export const DarkThemeColorBorderElementHoverL1 = "rgba(151, 151, 151, 0.5)";
export const DarkThemeColorBorderElementHoverL2 = "rgba(151, 151, 151, 0.5)";
export const DarkThemeColorBorderElementSelectedL0 = "#cc0d12";
export const DarkThemeColorBorderElementSelectedL1 = "#cc0d12";
export const DarkThemeColorBorderElementSelectedL2 = "#cc0d12";
export const DarkThemeColorFocusRing = "#00a5db";
export const DarkThemeShadowSpecial =
  "2px 2px #000000, 3px 3px 0 #cd0400, 3px 1.5px 0 #cd0400, 1.75px 3px 0 #cd0400";
export const DarkThemeShadowButton = "1px 1px 0 #000000, 2px 2px 0 #cd0400";
export const DarkThemeShadowButtonHeavyMetal =
  "1px 1px 0 #000000, 2px 2px 0 #2c2c2c";
export const DarkThemeFilterWhiteToBlack = "none";
export const DimensionsMaxWidthSiteNoPx = 1200;
export const DimensionsMaxWidthSite = "1200px";
export const IconSize50 = "8px";
export const IconSize75 = "12px";
export const IconSize100 = "16px";
export const IconSize150 = "24px";
export const IconSize200 = "32px";
export const IconSize300 = "48px";
export const IconSize400 = "64px";
export const IconSize500 = "80px";
export const IconSize625 = "100px";
export const IconSize750 = "120px";
export const LightThemeColorTextRequiredMarker = "#cc0d12";
export const LightThemeColorTextLink = "#00a5db";
export const LightThemeColorTextError = "#cd0400";
export const LightThemeColorTextSuccess = "#398087";
export const LightThemeColorTextHighlight = "#000000";
export const LightThemeColorTextPromo = "#cd0400";
export const LightThemeColorTextL0 = "#333333";
export const LightThemeColorTextL1 = "#333333";
export const LightThemeColorTextL2 = "#333333";
export const LightThemeColorTextSecondaryL0 = "#555555";
export const LightThemeColorTextSecondaryL1 = "#555555";
export const LightThemeColorTextSecondaryL2 = "#555555";
export const LightThemeColorTextElementL0 = "#333333";
export const LightThemeColorTextElementL1 = "#333333";
export const LightThemeColorTextElementL2 = "#333333";
export const LightThemeColorTextSecondaryElementL0 = "#555555";
export const LightThemeColorTextSecondaryElementL1 = "#555555";
export const LightThemeColorTextSecondaryElementL2 = "#555555";
export const LightThemeColorTextElementLabelL0 = "#000000";
export const LightThemeColorTextElementLabelL1 = "#000000";
export const LightThemeColorTextElementLabelL2 = "#000000";
export const LightThemeColorTextElementHintL0 =
  "var(--color-secondary-text-l0)";
export const LightThemeColorTextElementHintL1 =
  "var(--color-secondary-text-l1)";
export const LightThemeColorTextElementHintL2 =
  "var(--color-secondary-text-l2)";
export const LightThemeColorTextElementSelectedL0 = "#ffffff";
export const LightThemeColorTextElementSelectedL1 = "#ffffff";
export const LightThemeColorTextElementSelectedL2 = "#ffffff";
export const LightThemeColorDivider = "#cccccc";
export const LightThemeColorBgL0 = "#ffffff";
export const LightThemeColorBgL1 = "#ffffff";
export const LightThemeColorBgL2 = "#f6f6f6";
export const LightThemeColorBgHoverL0 = "#ececec";
export const LightThemeColorBgHoverL1 = "#ececec";
export const LightThemeColorBgHoverL2 = "#ececec";
export const LightThemeColorBgTransparentL0 = "rgba(255, 255, 255, 0)";
export const LightThemeColorBgTransparentL1 = "rgba(255, 255, 255, 0)";
export const LightThemeColorBgTransparentL2 = "rgba(246, 246, 246, 0)";
export const LightThemeColorBgTransparent050L0 = "rgba(255, 255, 255, 0.5)";
export const LightThemeColorBgTransparent050L1 = "rgba(255, 255, 255, 0.5)";
export const LightThemeColorBgTransparent050L2 = "rgba(246, 246, 246, 0.5)";
export const LightThemeColorBgElementL0 = "#ffffff";
export const LightThemeColorBgElementL1 = "#f6f6f6";
export const LightThemeColorBgElementL2 = "#ffffff";
export const LightThemeColorBgElementHoverL0 = "#ececec";
export const LightThemeColorBgElementHoverL1 = "#ececec";
export const LightThemeColorBgElementHoverL2 = "#ececec";
export const LightThemeColorBgElementSelectedL0 = "#cc0d12";
export const LightThemeColorBgElementSelectedL1 = "#cc0d12";
export const LightThemeColorBgElementSelectedL2 = "#cc0d12";
export const LightThemeColorBorderL0 = "#cccccc";
export const LightThemeColorBorderL1 = "#cccccc";
export const LightThemeColorBorderL2 = "#cccccc";
export const LightThemeColorBorderHoverL0 = "#9c9c9c";
export const LightThemeColorBorderHoverL1 = "#9c9c9c";
export const LightThemeColorBorderHoverL2 = "#9c9c9c";
export const LightThemeColorBorderElementL0 = "#cccccc";
export const LightThemeColorBorderElementL1 = "#cccccc";
export const LightThemeColorBorderElementL2 = "#cccccc";
export const LightThemeColorBorderElementHoverL0 = "#9c9c9c";
export const LightThemeColorBorderElementHoverL1 = "#9c9c9c";
export const LightThemeColorBorderElementHoverL2 = "#9c9c9c";
export const LightThemeColorBorderElementSelectedL0 = "#cc0d12";
export const LightThemeColorBorderElementSelectedL1 = "#cc0d12";
export const LightThemeColorBorderElementSelectedL2 = "#cc0d12";
export const LightThemeColorFocusRing = "#00a5db";
export const LightThemeShadowSpecial =
  "2px 2px #ffffff, 3px 3px 0 #cd0400, 3px 1.5px 0 #cd0400, 1.75px 3px 0 #cd0400";
export const LightThemeShadowButton = "1px 1px #ffffff, 2px 2px 0 #cd0400";
export const LightThemeShadowButtonHeavyMetal =
  "1px 1px 0 #ffffff, 2px 2px 0 #2c2c2c";
export const LightThemeFilterWhiteToBlack =
  "brightness(0) saturate(100%) invert(4%) sepia(8%) saturate(795%) hue-rotate(48deg) brightness(99%) contrast(99%)";
export const Spacing100 = "1rem";
export const Spacing150 = "1.5rem";
export const Spacing200 = "2rem";
export const Spacing250 = "2.5rem";
export const Spacing300 = "3rem";
export const Spacing350 = "3.5rem";
export const Spacing400 = "4rem";
export const Spacing450 = "4.5rem";
export const Spacing500 = "5rem";
export const Spacing550 = "5.5rem";
export const Spacing750 = "7.5rem";
export const Spacing0125 = ".125rem";
export const Spacing025 = ".25rem";
export const Spacing050 = ".5rem";
export const Spacing0625 = ".625rem";
export const Spacing075 = ".75rem";
export const FontFamilyBody = "'Asap', 'Asap Fallback'";
export const FontFamilyBodyBase = "Asap";
export const FontFamilyBodyFallback = "Asap Fallback";
export const FontFamilyDisplay = "'MrAlex', 'MrAlex Fallback'";
export const FontFamilyDisplayBase = "MrAlex";
export const FontFamilyDisplayFallback = "MrAlex Fallback";
export const FontFamilyVikingPointsSign = "vikingfont";
export const FontSizeBase1650 = "10px";
export const FontSizeBase1675 = "12px";
export const FontSizeBase16125 = "18px";
export const FontSizeBase16150 = "22px";
export const FontSizeBase16175 = "28px";
export const FontSizeBase16200 = "34px";
export const FontSizeBase16225 = "40px";
export const FontSizeBase16250 = "48px";
export const FontSizeBase16275 = "58px";
export const FontSizeBase16300 = "68px";
export const FontSizeBase16325 = "70px";
export const FontSizeBase16350 = "84px";
export const FontSizeBase16400 = "96px";
export const FontSizeBase16Base = "16px";
export const FontSizeBase1850 = "12px";
export const FontSizeBase1875 = "14px";
export const FontSizeBase18125 = "22px";
export const FontSizeBase18150 = "26px";
export const FontSizeBase18175 = "32px";
export const FontSizeBase18200 = "38px";
export const FontSizeBase18225 = "46px";
export const FontSizeBase18250 = "54px";
export const FontSizeBase18275 = "64px";
export const FontSizeBase18300 = "76px";
export const FontSizeBase18325 = "86px";
export const FontSizeBase18350 = "102px";
export const FontSizeBase18400 = "122px";
export const FontSizeBase18Base = "18px";
export const FontWeightRegular = 400;
export const FontWeightMedium = 500;
export const FontWeightBold = 700;
export const FontWeightExtraBold = 800;
export const LineHeight110 = "110%";
export const LineHeight133 = "133%";
export const LineHeight140 = "140%";
export const LineHeight150 = "150%";
export const LineHeight160 = "160%";
export const LineHeight090 = "90%";
export const LetterSpacing0 = "0";
export const LetterSpacingN06 = "-0.006em";
export const LetterSpacingN05 = "-0.005em";
export const LetterSpacingN02 = "-0.002em";
export const LetterSpacingN015 = "-0.0015em";
export const LetterSpacing04 = "0.004em";
export const LetterSpacing05 = "0.005em";
